'use strict'

import ApiClient from './ApiClient'

export default class AppSuiteJobRepository {
  /**
   * AppSuite連携ジョブ一覧(検索)を取得する
   * @param {object} data 検索条件のbody情報
   * @returns {*}
   */
  postSearch (data) {
    // クエリで指定するデータを移動する
    const params = {
      page: data.page,
      sort_item: data.sort_item,
      direction: data.direction
    }
    delete data.page
    delete data.sort_item
    delete data.direction

    return ApiClient().post(`/appsuite-jobs/search`, data, { params })
  }

  /**
   * AppSuite連携ジョブを1件作成する
   * @param {object} formData
   * @returns {*}
   */
  post (formData) {
    return ApiClient().post(`/appsuite-jobs`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * AppSuite連携ジョブを1件取得する
   * @param {string|int} id
   * @returns {*}
   */
  get (id) {
    return ApiClient().get(`/appsuite-jobs/${id}`)
  }

  /**
   * AppSuite連携ジョブを1件更新する
   * @param {string|int} id
   * @param {object} formData
   * @returns {*}
   */
  put (id, formData) {
    formData.append('_method', 'PUT')

    return ApiClient().post(`/appsuite-jobs/${id}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  }

  /**
   * AppSuite連携ジョブを1件削除する
   * @param {string|int} id
   * @returns {*}
   */
  delete (id) {
    return ApiClient().delete(`/appsuite-jobs/${id}`)
  }

  /**
   * 指定された複数IDのAppsuite連携ジョブ情報を一括削除します。
   * @param {object} data
   * @returns {*}
   */
  bulkDelete (data) {
    return ApiClient().post(`/appsuite-jobs/delete`, data)
  }

  /**
   * AppSuite連携ジョブのステータスファイルを確認
   * @returns {*}
   */
  getStatus () {
    return ApiClient().get(`/appsuite-jobs/status`)
  }

  /**
   * AppSuite連携ジョブを実行
   * @param id
   * @returns {*}
   */
  postExecute (id) {
    return ApiClient().post(`/appsuite-jobs/execute/${id}`)
  }

  /**
   * AppSuite連携ジョブをキャンセル
   * @param {string|int} id
   * @returns {*}
   */
  postCancel (id) {
    return ApiClient().post(`/appsuite-jobs/cancel/${id}`)
  }

  /**
   * AppSuiteインポートに失敗した際にAppSuiteから得られるログファイルをダウンロードします。
   * @param {object} options
   * @param {string|int} id
   * @returns {*}
   */
  getErrorLogs (options, id) {
    return ApiClient().get(`/appsuite-jobs/error-logs/${id}`, options)
  }

  /**
   * AppSuiteインポートに失敗したCSVファイルをダウンロードします。（未使用）
   * @param {object} params
   * @param {string|int} id
   * @returns {*}
   */
  getErrorCsv (options, id) {
    return ApiClient().get(`/appsuite-jobs/csvs/${id}`, options)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/AppSuiteJobRepository.js